function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.01 23.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    style: {
      fill: "none",
      stroke: "#2b2b2b",
      strokeLinecap: "round",
      strokeWidth: 3
    },
    x1: 22.51,
    y1: 1.5,
    x2: 2,
    y2: 22.01
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    style: {
      fill: "none",
      stroke: "#2b2b2b",
      strokeLinecap: "round",
      strokeWidth: 3
    },
    x1: 1.5,
    y1: 1.5,
    x2: 22.01,
    y2: 22.01
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/IconX.65ea55e0ff0fae493de8baac6370edec.svg";
export { ForwardRef as ReactComponent };